//Development
//export const BASE_URL = "";
//UAT
export const BASE_URL = "https://rndhelpdesk-uat.iffco.com";
//Production
//export const BASE_URL = "https://rndhelpdesk.iffco.com";
export const Time_OUT = 1 * 60 * 1000; // configure session time out time
export const pattern = /^[a-zA-Z0-9\s.,_@\-:;!$#@&\-\+\)\(€¥£{}\]\[%]*$/;
